"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles = ({ typography, spacing, palette }) => ({
    headlineText: {
        fontWeight: typography.fontWeightLight,
        lineHeight: spacing(4),
        letterSpacing: 0.2,
        minWidth: 400,
    },
    header: {
        marginBottom: spacing(2),
    },
    headlineIcon: {
        maxHeight: spacing(4),
        maxWidth: spacing(4),
        width: 'auto',
        height: 'auto',
        marginRight: spacing(1),
        marginBottom: 4,
        color: palette.icon.secondary,
    },
    rulesTable: {
        tableLayout: 'fixed',
    },
    thFont: {
        fontWeight: typography.fontWeightMedium,
        color: palette.text.strong,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    tableCell: {
        verticalAlign: 'middle',
        position: 'relative',
    },
});
exports.default = styles;
